import { render, staticRenderFns } from "./RentalBookDamaged.vue?vue&type=template&id=03ac6f8f&scoped=true"
import script from "./RentalBookDamaged.vue?vue&type=script&lang=js"
export * from "./RentalBookDamaged.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ac6f8f",
  null
  
)

export default component.exports